function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `[env] Required build-time variable ${name} is unset. ` +
        "Set it in .env or pass it as a build arg.",
    );
  }
  return value;
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/$/, "");
}

export const env = {
  apiUrl: trimTrailingSlash(required("VITE_API_URL", import.meta.env.VITE_API_URL)),
  appOrigin: trimTrailingSlash(
    required("VITE_APP_ORIGIN", import.meta.env.VITE_APP_ORIGIN),
  ),
} as const;
